import network from '@/services/network';
import { ErrorResponse } from '@/utils';

export type SearchResultType = 'case' | 'meeting' | 'task' | 'card';

export interface GlobalSearchResult {
  type: SearchResultType;
  id: number;
  title: string;
  subtitle: string | null;
  url: string;
  target: '_self' | '_blank';
}

const global = async (
  q: string,
  signal?: AbortSignal,
): Promise<GlobalSearchResult[]> => {
  try {
    const { data } = await network.get<{ results: GlobalSearchResult[] }>(
      '/search',
      { params: { q }, signal },
    );
    return data.results;
  } catch (error) {
    if ((error as Error).name === 'CanceledError') return [];
    throw new ErrorResponse(error);
  }
};

const search = {
  global,
};

export default search;
